<template>
  <div class="fill-height">
    <v-card
        height="100%"
        class="d-flex flex-column rounded-lg"
    >
      <div class="d-flex justify-space-between align-center">
        <v-card-title class="text-break"><strong>{{ $t('cards.titles.yourAchievements') }}</strong></v-card-title>
        <v-btn
            outlined
            icon
            x-small
            color="primary"
            class="mx-4"
            @click.prevent="showDisclaimerDialog = true"
        >
          <v-icon x-small>fal fa-info</v-icon>
        </v-btn>
      </div>
      <!--<v-card-title class="text-break"><strong>{{ $t('cards.titles.yourAchievements') }}</strong></v-card-title>-->
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-if="!isLoading" class="fill-height">
        <div class="d-flex flex-column col-12 ma-0 pa-0 align-stretch">
          <div class="col-12 pa-2 py-6 d-flex flex-column align-start justify-center rounded-lg" :style="'outline: 2px solid ' + $vuetify.theme.currentTheme.accent + ';'">
            <div class="d-flex align-center">
              <div class="mr-3 text-h6"><strong>{{ $t('labels.real-age') }}</strong></div>
              <div class="secondary--text text-h6 font-weight-medium"><span v-if="profile && profile.organizationSettings && profile.organizationSettings.birthdayType !== 'EXACT'">+- </span>{{ realAge }}</div>
            </div>
            <div class="d-flex align-center">
              <div class="mr-3 text-h6"><strong>{{ $t('labels.bio-age') }}</strong></div>
              <div class="secondary--text text-h6 font-weight-medium">{{ bioAgeList.length ? Math.round(bioAgeList[0]["bio_age"]) : '-' }}</div>
            </div>
            <!--<div class="mr-3"><strong>{{ $t('labels.real-age') }}</strong></div>
            <div class="secondary--text text-h4 font-weight-medium"><span v-if="profile.organizationSettings.birthdayType !== 'EXACT'">+- </span>{{ realAge }}</div>-->
          </div>
          <div v-if="bioAgeList.length" class="col-12 pa-2 mt-n6 d-flex flex-nowrap align-center justify-center">
            <v-chip label class="rounded-lg" color="success" v-if="bioAgeList[0]['bio_age'] < realAge">
              <v-icon small>
                fal fa-arrow-down-long
              </v-icon>
              <span class="ml-2 font-weight-medium text-h6">{{ Math.round(((realAge - bioAgeList[0]['bio_age']) / realAge) * 100) }} %</span>
            </v-chip>
            <v-chip label class="rounded-lg" color="error" v-else-if="bioAgeList[0]['bio_age'] > realAge">
              <v-icon small>
                fal fa-arrow-up-long
              </v-icon>
              <span class="ml-2 font-weight-medium text-h6">{{ Math.round(((bioAgeList[0]['bio_age'] - realAge) / realAge) * 100) }} %</span>
            </v-chip>
          </div>
          <!--<div class="col-12 pa-2 d-flex justify-center"><v-divider></v-divider></div>
          <div class="col-12 pa-2 d-flex justify-center">{{ $moment(bioAgeList[0].start).format('DD/MM/YYYY') }} - {{ $moment(bioAgeList[0].end).format('DD/MM/YYYY') }}</div>-->
          <div class="d-flex flex-wrap">
            <div class="d-flex justify-start align-center col-12 ma-0 pa-0">
              <div class="col-4">
                <v-icon x-large color="accent">fal fa-shoe-prints</v-icon>
              </div>
              <div class="col-8">
                <div class="font-weight-bold">{{ dailySummary.length && dailySummary[0].steps > 0 ? dailySummary[0].steps : '-' }}</div>
                <div class="font-weight-bold">{{ $t('labels.params.steps') }}</div>
              </div>
            </div>
            <div class="d-flex justify-start align-center col-12 ma-0 pa-0">
              <div class="col-4">
                <v-icon x-large color="accent" class="mr-3">fal fa-location-dot</v-icon>
              </div>
              <div class="col-8">
                <div class="font-weight-bold">{{ dailySummary.length && dailySummary[0].distance > 0 ? Math.round(dailySummary[0].distance) : '-' }} m</div>
                <div class="font-weight-bold">{{ $t('labels.params.distance') }}</div>
              </div>
            </div>
            <div class="d-flex justify-start align-center col-12 ma-0 pa-0">
              <div class="col-4">
                <v-icon x-large color="accent" class="mr-3">fal fa-fire-flame</v-icon>
              </div>
              <div class="col-8">
                <div class="font-weight-bold">{{ dailySummary.length && dailySummary[0].calories > 0 ? Math.round(dailySummary[0].calories) : '-' }}</div>
                <div class="font-weight-bold">{{ $t('labels.params.calories') }}</div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end pt-0" v-if="!isLoading">
        <v-btn text color="primary" @click.prevent="navigate('/connections/bio-age')">
          {{ $t('buttons.showMore') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- DISCLAIMER DIALOG -->
    <v-dialog
        v-model="showDisclaimerDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-card-title></v-card-title>
        <v-card-text class="fill-height">
          <div v-html="$t('weFitter.bioAgeDisclaimer')">
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end mt-auto">
          <v-btn
              color="primary"
              depressed
              class="rounded-lg"
              @click.prevent="showDisclaimerDialog = false"
          >
            {{ $t('buttons.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-bio-age-widget",
  data() {
    return {
      isLoading: false,
      profile: {},
      bioAgeList: [],
      bioAgeValues: [],
      bioAgeLabels: [],
      dailySummary: [],
      realAge: 1,
      showDisclaimerDialog: false
    }
  },

  mounted(){
    this.fetchProfileAndBioAge()
  },

  methods: {
    async fetchProfileAndBioAge() {
      this.isLoading = true
      const that = this
      await api.account.getProfile()
          .then((res) => {
            that.profile = res.data
          })
      //await api.connections.activateBioAge()
      await this.fetchBioAgeList()
      await this.fetchDailySummary()
      this.isLoading = false
    },

    async fetchBioAgeList() {
      let storage = localStorage.getItem(this.profile.identifier + '.bio_age')
      if (storage) { storage = JSON.parse(storage)}
      if (!storage || this.$moment(storage.timestamp).isBefore(this.$moment().subtract(4, 'hours'))){
        let profile = await api.connections.getWefitterProfile().then((res) => { return res.data })
        if (!profile ||
            !profile.birthdate ||
            !profile.gender ||
            !['m', 'f', 'x'].includes(profile.gender.toLowerCase()) ||
            (this.profile.gender.toLowerCase() !== 'u' && this.profile.gender.toLowerCase() !== profile.gender.toLowerCase()) ||
            this.profile.birthDate !== profile.birthdate
        ){ await api.connections.activateBioAge() }
        await api.connections.getWefitterBioAgeList(this.$moment().subtract(56, 'days').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'))
            .then((res) => {
              this.bioAgeList = res.data.sort((b, a) => { return this.$moment(a.end).unix() - this.$moment(b.end).unix() })
              let bioAgeStorage = { timestamp: this.$moment(), bioAgeList: this.bioAgeList}
              localStorage.setItem(this.profile.identifier + '.bio_age', JSON.stringify(bioAgeStorage))
            })
      } else {
        this.bioAgeList = storage.bioAgeList
      }
      this.realAge = this.$moment().diff(this.profile.birthDate, 'years')
    },

    async fetchDailySummary() {
      await api.connections.getWefitterDailySummary(this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'))
          .then((res) => {
            this.dailySummary = res.data
          })
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    }
  }
}
</script>

<style scoped>

</style>
